/**
 * 最小 IndexedDB 封装，供画板加载本地图片
 */

const DB_NAME = 'pigai_db'
const STORE_NAME = 'images'
const DRAFT_STORE = 'drafts'
const VERSION = 2

let db = null

/* 打开数据库 */
async function openDB () {
  return new Promise((resolve, reject) => {
    if (db) return resolve(db)
    const request = indexedDB.open(DB_NAME, VERSION)
    request.onerror = () => reject(request.error)
    request.onsuccess = () => {
      db = request.result
      resolve(db)
    }
    request.onupgradeneeded = () => {
      const conn = request.result
      if (!conn.objectStoreNames.contains(STORE_NAME)) {
        const store = conn.createObjectStore(STORE_NAME, { keyPath: 'id' })
        store.createIndex('name', 'name', { unique: false })
      }
      if (!conn.objectStoreNames.contains(DRAFT_STORE)) {
        conn.createObjectStore(DRAFT_STORE, { keyPath: 'id' })
      }
    }
  })
}

/* 根据 id 获取图片 */
export async function getImage (id) {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([STORE_NAME], 'readonly')
    const store = tx.objectStore(STORE_NAME)
    const req = store.get(id)
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
}

export async function saveDraft (draft) {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([DRAFT_STORE], 'readwrite')
    const store = tx.objectStore(DRAFT_STORE)
    const req = store.put(draft)
    req.onsuccess = () => resolve(true)
    req.onerror = () => reject(req.error)
  })
}

export async function getDraft (id) {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([DRAFT_STORE], 'readonly')
    const store = tx.objectStore(DRAFT_STORE)
    const req = store.get(id)
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
}

export async function deleteDraftByBaseId (id) {
  const db = await openDB()
  return new Promise((resolve, reject) => {
    const tx = db.transaction([DRAFT_STORE], 'readwrite')
    const store = tx.objectStore(DRAFT_STORE)
    const req = store.delete(id)
    req.onsuccess = () => resolve(true)
    req.onerror = () => reject(req.error)
  })
}